export default {
  district: [
    { label: 'District Closed, No School', color: '#E8350F' },
    { label: 'No School - All Students', color: '#FFD700' },
    { label: 'No School - Middle School Students', color: '#CB78F1' },
    { label: 'No School - Elementary School Students', color: '#2fc856' },
    { label: 'PLC 2-Hour Late Start', color: '#70ddfb' },
    { label: 'Other Events', color: '#bababa' },
  ],
  aahs: [
    { label: 'District Closed, No School', color: '#E8350F' },
    { label: 'No School - All Students', color: '#FFD700' },
    { label: 'PLC 2-Hour Late Start', color: '#70ddfb' },
    { label: 'Blue Days', color: '#0c5cbe' },
    { label: 'Silver Days', color: '#CED0D3' },
    { label: 'Other Events', color: '#bababa' },
  ],
  dcchs: [
    { label: 'District Closed, No School', color: '#E8350F' },
    { label: 'No School - All Students', color: '#FFD700' },
    { label: 'PLC 2-Hour Late Start', color: '#70ddfb' },
    { label: 'Purple Days', color: '#A739EE' },
    { label: 'Silver Days', color: '#CED0D3' },
    { label: 'Other Events', color: '#bababa' },
  ],
  lhs: [
    { label: 'District Closed, No School', color: '#E8350F' },
    { label: 'No School - All Students', color: '#FFD700' },
    { label: 'PLC 2-Hour Late Start', color: '#70ddfb' },
    { label: 'Blue Days', color: '#0c5cbe' },
    { label: 'Red Days', color: '#FBB5B5' },
    { label: 'Other Events', color: '#bababa' },
  ],
  pchs: [
    { label: 'District Closed, No School', color: '#E8350F' },
    { label: 'No School - All Students', color: '#FFD700' },
    { label: 'PLC 2-Hour Late Start', color: '#70ddfb' },
    { label: 'Blue Days', color: '#0c5cbe' },
    { label: 'Green Days', color: '#53ce32' },
    { label: 'Other Events', color: '#bababa' },
  ],
  rhs: [
    { label: 'District Closed, No School', color: '#E8350F' },
    { label: 'No School - All Students', color: '#FFD700' },
    { label: 'PLC 2-Hour Late Start', color: '#70ddfb' },
    { label: 'Blue Days', color: '#0c5cbe' },
    { label: 'Gold Days', color: '#C8B223' },
    { label: 'Other Events', color: '#bababa' },
  ],
  vhs: [
    { label: 'District Closed, No School', color: '#E8350F' },
    { label: 'No School - All Students', color: '#FFD700' },
    { label: 'PLC 2-Hour Late Start', color: '#70ddfb' },
    { label: 'Blue Days', color: '#0c5cbe' },
    { label: 'Silver Days', color: '#CED0D3' },
    { label: 'Other Events', color: '#bababa' },
  ],
}
